import React from 'react';
import { LifeBuoy } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/**
 * BILL-7 — shown to Northline staff inside a support session: whose company
 * this is, whether changes are allowed, when access ends, and End Session.
 */
export default function SupportSessionBanner() {
  const { user, endSupportSession } = useAuth();
  const session = user?.support_session;
  if (!session) return null;

  const end = async () => {
    await endSupportSession();
    window.location.href = '/admin/company-access';
  };

  return (
    <div
      className={`${session.kind === 'break_glass' ? 'bg-red-700' : 'bg-violet-700'} text-white px-4 py-2 text-sm flex items-center justify-center gap-3 flex-wrap`}
      data-testid="support-session-banner"
    >
      <LifeBuoy className="w-4 h-4 shrink-0" />
      <span className="font-semibold">
        {session.kind === 'break_glass' ? 'Emergency Access' : 'Northline Support Session'}: {session.company_name}
      </span>
      <span className="opacity-90" data-testid="support-session-mode">
        {session.allow_writes ? 'Changes allowed' : 'Read-only'}
      </span>
      {session.expires_at && (
        <span className="opacity-90">Ends {new Date(session.expires_at).toLocaleTimeString()}</span>
      )}
      <button
        type="button"
        onClick={end}
        className="bg-white text-slate-900 px-3 py-1 rounded-md font-semibold text-xs hover:bg-slate-100"
        data-testid="end-support-session"
      >
        End Session
      </button>
    </div>
  );
}
